"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PinIconSmall = PinIconSmall;
exports.default = PinIcon;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("./shared/icon-base"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function PinIcon(props) {
  return (0, _core.jsx)(_iconBase.default, props, (0, _core.jsx)("path", {
    d: "M12 1C7.04932 1 3.02197 4.87402 3.02197 9.63672C3.02197 14.1182 5.5 16.4463 7.68652 18.5C9.46435 20.1709 11 21.6133 11 24H13C13 21.6133 14.5356 20.1709 16.3135 18.5C18.5 16.4463 20.978 14.1182 20.978 9.63672C20.978 4.87402 16.9507 1 12 1ZM14.9443 17.043C13.8638 18.0576 12.7632 19.0918 12 20.3711C11.2368 19.0918 10.1362 18.0576 9.05566 17.043C6.98144 15.0938 5.02197 13.2529 5.02197 9.63672C5.02197 5.97754 8.15234 3 12 3C15.8477 3 18.978 5.97754 18.978 9.63672C18.978 13.2529 17.0186 15.0938 14.9443 17.043ZM14 10C14 11.1045 13.1046 12 12 12C10.8955 12 10 11.1045 10 10C10 8.89539 10.8955 8 12 8C13.1046 8 14 8.89539 14 10Z",
    fill: "currentColor"
  }));
}
function PinIconSmall(props) {
  return (0, _core.jsx)(PinIcon, _extends({
    size: "small"
  }, props));
}